import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const InlineEllipsis = ({ text, className }) => {
  const ref = React.useRef(null);
  const [isTruncated, setIsTruncated] = React.useState(false);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;

    setIsTruncated(el.scrollWidth > el.clientWidth);
  }, [text]);

  const content = (
    <span
      ref={ref}
      className={className}
      style={{
        display: "inline-block",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        verticalAlign: "middle",
      }}
    >
      {text}
    </span>
  );

  if (!isTruncated) return content;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip className="tooltip-name" id="tooltip-username">
          {text}
        </Tooltip>
      }
    >
      {content}
    </OverlayTrigger>
  );
};